export const LANDLORD_HEADER = 'Landlord';
export const LOCATION_HEADER = 'Property Address';
export const CATEGORY_HEADER = 'Category';
export const TYPE_HEADER = 'Type';
export const DATE_HEADER = 'Submitted Date';
export const ACTIONS_HEADER = 'Actions';
export const STATUS_HEADER = 'Status'
